import {useEffect}  from "react";

import {getMainWidth , handelTitle} from '../../utils'
import {ExploreIcon2 , ExploreIcon3} from '../../utils/allImgs'


import Breadcrumb from '../../components/Breadcrumb'
import SecNewListed from '../../components/SecNewListed'
import SecLiveAuctions from '../../components/SecLiveAuctions'
import SectionHeading from '../../components/SectionHeading'
import './Explore.css'

/**
 * Explore page container (Style 1).
 *
 * Landing page for browsing new items and live auctions.
 * Features:
 * - Latest items section (SecNewListed)
 * - Hot auctions section (SecLiveAuctions)
 * - Header with background image and breadcrumb
 *
 * @module containers/Explore
 * @category Containers
 * @param {Array} props.initialNewListed - Prefetched new listed items from loader
 * @param {Array} props.initialAuctions - Prefetched live auctions from loader
 * @returns {React.ReactElement} Rendered explore page
 */
const ExploreContainer = ({ initialNewListed = [], initialAuctions = [] }) => {

  useEffect(() => {
    // document.title = 'Explore'
    handelTitle('Explore')
    getMainWidth()
  },[])

  return (
    <>
        <Breadcrumb text1='Explore Style 1' text2='Explore Style 1'/>
      <main className="main-content mt-1 border-radius-lg">
        
        <SectionHeading 
                        img={ExploreIcon2}
                        text='Latest Items'
                        title='New Listed Items'
                      />

        <SecNewListed initialItems={initialNewListed} />

        <SectionHeading
                        img={ExploreIcon3}
                        text='Hot Auctions'
                        title='Live Auctions'
                      />

        <SecLiveAuctions initialAuctions={initialAuctions} />

      </main>
    </>
  );
}

export default ExploreContainer;

